import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getImageByWidth } from '../../utils/api';
import { setFullHeight } from '../../actions/uiActions';
import Footer from '../PageGroup/Footer';
import us from '../../assets/about-us.svg';
import ru from '../../assets/about-ru.svg';


class PageTitle extends Component {
  constructor (props) {
    super(props);
    this.state = { containerMinHeight: 0 };
  }

  UNSAFE_componentWillMount () { // eslint-disable-line camelcase
    const { actions } = this.props;
    actions.setFullHeight(false);
  }

  componentDidMount () {
    this.setState({
      containerMinHeight: window.innerHeight - this.container.getBoundingClientRect().top,
    });
  }

  render () {
    const { name, previewImages, pageBody, displayLeadImage, displayFooter, footerLinks } = this.props;
    const { containerMinHeight } = this.state;
    const image = getImageByWidth(previewImages.posterFrame, 900);
    const imageBlock = displayLeadImage && image && (
      <div className="page-group-lead-image">
        <img src={image.url} alt={name} />
      </div>
    );
    return (
      <div className="page-group-stage" ref={elem => this.container = elem} style={{ minHeight: containerMinHeight }}>
        <div className="title-wrapper">
          <div className="page-group-bg-wrapper">
            {displayFooter && <img className="ru d-none d-lg-block" src={ru} width={420} alt="" />}
            {displayFooter && <img className="us d-none d-lg-block" src={us} width={420} alt="" />}
            <div className="page-group-content-wrapper">
              <header>
                <h2 className="heading-alt mb-3">{name}</h2>
              </header>
              <div className="page-group-content">
                {imageBlock}
                <div className="body-copy" dangerouslySetInnerHTML={{ __html: pageBody }} />
              </div>
            </div>
          </div>
        </div>
        {displayFooter ? <Footer links={footerLinks} /> : null}
      </div>
    );
  }
}

PageTitle.propTypes = {
  name: PropTypes.string,
  slug: PropTypes.string,
  previewImages: PropTypes.object,
  pageBody: PropTypes.string,
  displayLeadImage: PropTypes.bool,
  displayFooter: PropTypes.bool,
  footerLinks: PropTypes.arrayOf(PropTypes.object),
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ setFullHeight }, dispatch),
});

export default connect(null, mapDispatchToProps)(PageTitle);



// WEBPACK FOOTER //
// ./src/components/Title/PageTitle.js